/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "noattr.number",
    title: "Number (No Attributes)",
    description: "Raw number type for schema validation (no attributes).",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validInt: {
            must: true,
            run: function () {
                return validate({ title: "Test", type: "number" }, 42);
            }
        },
        invalidString: {
            throw: "fields.noattr.number.invalid",
            run: function () {
                return validate({ title: "Test", type: "number" }, "not a number");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Number",
            description: "The value must be a number.",
            template: "Expected a number but received ${typeof}"
        }
    }
});

function validate(spec, data) {
    if (typeof data !== "number") {
        _.errors.invalid.throw({ typeof: typeof data });
    }
}
module.exports.validate = validate;
